export default __webpack_public_path__ + "static/media/mern.4c5182e8.jpg";